// extracted by mini-css-extract-plugin
module.exports = {"background":"VideoBlock_background__KBECH","image":"VideoBlock_image__V5VjN","video":"VideoBlock_video__UCntw","fullScreenVideo":"VideoBlock_fullScreenVideo__cwL3i"};